// extracted by mini-css-extract-plugin
module.exports = {"productCard":"RelatedProducts_productCard__9oIjY","condensed":"RelatedProducts_condensed__l_2ef"};